import { render } from "./UserCabinet.vue?vue&type=template&id=8ee07e62"
import script from "./UserCabinet.vue?vue&type=script&lang=js"
export * from "./UserCabinet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__